export default __webpack_public_path__ + "static/Entenda0021-2970ac95f2991960457385b305810e02.jpg";